<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <CancelPopup
      v-if="cancelPopupVisible"
      :popupVisible="cancelPopupVisible"
      :propsData="constructData"
      :title="'해지정보 입력'"
      @popupClose="cancelPopupClose"
    />

    <v-sheet class="contents-container main_bg">
      <v-sheet class="w-full code-flex">
        <i-card-vertical v-if="!isMembership" class="pr-3 w-hfull monthly-guide-card" headerTitle="정액 요금제 안내" device="web">
          <template v-slot:body>
            <v-row class="h-full d-flex flex-column monthly-guide-inner">
              <v-row class="align-center justify-center flex-column gap-2 monthly-guide-no-member">
                <h3 class="monthly-guide-title">{{ '회원사가 아닙니다.' }}</h3>
                <h4 class="mt-2 monthly-guide-subtitle">{{ '일반 고객은 일반 요금제로만 등록이 가능합니다.' }}</h4>
              </v-row>
            </v-row>
          </template>
        </i-card-vertical>
        <i-card-vertical v-else-if="!activeMonthlyFee" class="pr-3 w-hfull monthly-guide-card" headerTitle="정액 요금제 안내" device="web">
          <template v-slot:body>
            <div class="align-center justify-center monthly-guide-body">
              <v-row class="monthly-guide-block">
                <h3 class="monthly-guide-section-title">{{ '◆ 정액 요금제란?' }}</h3>
              </v-row>
              <v-row class="monthly-guide-block">
                <v-col>
                  <v-row class="monthly-guide-paragraph">
                    <span>{{ '고객이 다수의 사업장(공사)를 관리하실 때 개별로 요금을 결제하는 대신' }}</span>
                    <span>{{ '일괄 결제하여 관리하실 수 있는 요금제 입니다.' }}</span>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="monthly-guide-block">
                <h3 class="monthly-guide-section-title">{{ '◆ 상세설명' }}</h3>
              </v-row>
              <v-row class="monthly-guide-block">
                <v-col>
                  <v-row class="monthly-guide-paragraph">
                    <span>{{ '1. 사업장(공사)의 공사비용이 정액 요금제 범위에 포함된다면' }}</span>
                    <span>{{ ' 추가 결제 없이 등록하여 소중안 시스템을 이용하실 수 있습니다.' }}</span>
                    <span>{{ '(*정액 요금제 범위는 각 요금제의 안내 문구를 참조해주십시오)' }}</span>
                    <br />
                  </v-row>
                  <v-row class="monthly-guide-example">
                    <span>{{ '예시) 정액 요금제 A(10억 미만 일괄결제) 를 사용중인 경우' }}</span>
                    <span>{{ '사업장(공사) #1 ㄱOO 공사 - 공사 비용 7억 ◀ 추가 결제 없이 이용 가능' }}</span>
                    <span>{{ '사업장(공사) #2 ㄴOO 공사 - 공사 비용 13억' }}</span>
                    <span>{{ '사업장(공사) #3 ㄷOO 공사 - 공사 비용 9억 ◀ 추가 결제 없이 이용 가능' }}</span>
                    <span>{{ '사업장(공사) #4 ㄹOO 공사 - 공사 비용 8억 ◀ 추가 결제 없이 이용 가능' }}</span>
                  </v-row>
                  <v-row class="monthly-guide-paragraph">
                    <span>{{ '2. 월1회 결제하는 구독형 요금제로 신용카드 결제만 가능합니다.' }}</span>
                    <span>{{ '3. 정액요금제 사용중이더라도 신규 사업장(공사) 등록시 공사승인이 필요합니다.' }}</span>
                    <br />
                  </v-row>
                  <v-row class="monthly-guide-flow">
                    <span>{{ '예시) 신규 사업장(공사)를 정액 요금제로 등록 신청 하는 경우 흐름도' }}</span>
                    <span>{{ '[사업장(공사) 등록] ─ [공사 승인] ─ [결제 요청 : ☞정액 요금제☜ 선택] ─ [소중안 시스템 사용]' }}</span>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="monthly-guide-block">
                <h3 class="monthly-guide-section-title">{{ '◆ 추가 안내 사항' }}</h3>
              </v-row>
              <v-row class="monthly-guide-block">
                <v-col>
                  <v-row class="monthly-guide-notice">
                    <span>{{ '요금제 사용중 기존 요금제의 업그레이드 / 중단 / 해지 / 결제수단 변경이 가능합니다.' }}</span>
                    <span>{{ '해지 시 환불규정에 따라 일할계산하여 환불해드립니다.' }}</span>
                    <span>{{ '카드 취소는 불가하며 해지 신청 시 현금환불 해드립니다.' }}</span>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </template>
        </i-card-vertical>
        <!-- 적용중인 요금제가 있을 경우-->
        <i-card-vertical v-else class="pr-3 w-hfull monthly-current-card" headerTitle="사용중인 요금제" device="web">
          <template v-slot:body>
            <v-card width="100%" height="100%" class="monthly-current-inner">
              <v-card class="d-flex monthly-current-fields" style="flex-direction: column; gap: 15px">
                <v-card class="monthly-info-row">
                  <div class="form-label monthly-form-label">현재 사용중인 요금제</div>
                  <v-row no-gutters>
                    <div class="monthly-info-value">{{ activeMonthlyFeeData.feeName }}</div>
                  </v-row>
                </v-card>
                <v-card class="monthly-info-row">
                  <div class="form-label monthly-form-label">활성화 기간</div>
                  <v-row no-gutters>
                    <div class="monthly-info-value">
                      {{ activeMonthlyFeeData.activeMonthlyFeeDtS + ' ~ ' + activeMonthlyFeeData.activeMonthlyFeeDtE }}
                    </div>
                  </v-row>
                </v-card>
                <v-card class="monthly-info-row">
                  <div class="form-label monthly-form-label">다음 자동 결제일</div>
                  <v-row no-gutters>
                    <div class="monthly-info-value">
                      {{ activeMonthlyFeeData.billingDueDt == null ? '자동결제 중단 됨' : activeMonthlyFeeData.billingDueDt }}
                    </div>
                  </v-row>
                </v-card>
                <v-card class="monthly-action-buttons">
                  <v-row>
                    <v-col cols="4">
                      <v-btn elevation="0" color="btn_sub" dark large class="rounded monthly-action-btn" @click="btnBillingInfoChange()"
                        >결제 수단 변경</v-btn
                      >
                    </v-col>
                    <v-col cols="4">
                      <v-btn
                        v-if="activeMonthlyFeeData.billingDueDt != null"
                        elevation="0"
                        color="btn_sub"
                        dark
                        large
                        class="rounded monthly-action-btn"
                        @click="btnStopBilling()"
                        >자동 결제 중단</v-btn
                      >
                      <v-btn v-else elevation="0" color="btn_sub" dark large class="rounded monthly-action-btn" @click="btnRestoreBilling()"
                        >자동 결제 복원</v-btn
                      >
                    </v-col>
                    <v-col cols="4">
                      <v-btn elevation="0" color="btn_sub" dark large class="rounded monthly-action-btn" @click="btnPaymentCancel()"
                        >사용 해지 신청</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card>
                <v-divider class="monthly-divider" />
                <v-card class="monthly-grid-section">
                  <div class="form-label monthly-form-label">정액 요금제 사용중인 사업장(공사) 목록</div>
                  <DxDataGrid
                    id="dxDataGrid"
                    width="100%"
                    height="90%"
                    :ref="dxDataGridRef"
                    :data-source="activeMonthlyCompList"
                    :remote-operations="false"
                    :hover-state-enabled="true"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :row-alternation-enabled="true"
                    :column-auto-width="false"
                    :show-borders="true"
                    :show-row-lines="true"
                    :focused-row-enabled="true"
                    key-expr="compId"
                    @focused-row-changed="onFocusedRowChanged"
                  >
                    <DxPaging />
                    <DxEditing mode="batch" :allow-updating="false" :select-text-on-edit-start="true" />
                    <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="single" />
                    <DxColumn
                      data-field="compNm"
                      data-type="string"
                      width="150px"
                      alignment="center"
                      caption="사업장(공사)명"
                      :allow-editing="false"
                    ></DxColumn>
                  </DxDataGrid>
                </v-card>
              </v-card>
            </v-card>
          </template>
        </i-card-vertical>
        <!-- 적용중인 요금제가 없을 경우-->
        <i-card-vertical v-if="!isMembership" class="pr-3 w-hfull monthly-guide-card" headerTitle="정액 요금제 결제" device="web">
          <template v-slot:body>
            <v-row class="h-full d-flex flex-column monthly-guide-inner">
              <v-row class="align-center justify-center flex-column gap-2 monthly-guide-no-member">
                <h3 class="monthly-guide-title">{{ '회원사가 아닙니다.' }}</h3>
                <h4 class="mt-2 monthly-guide-subtitle">{{ '일반 고객은 일반 요금제로만 등록이 가능합니다.' }}</h4>
              </v-row>
            </v-row>
          </template>
        </i-card-vertical>
        <i-card-vertical v-else-if="!activeMonthlyFee" class="w-hfull monthly-payment-card" headerTitle="정액 요금제 결제" device="web">
          <template v-slot:body>
            <v-card class="d-flex monthly-payment-body" style="flex-direction: column; gap: 15px">
              <v-row no-gutters class="monthly-payment-section">
                <div class="form-label monthly-form-label">요금제 선택</div>
                <v-item-group mandatory v-model="selection" class="monthly-fee-select-group">
                  <div class="monthly-fee-select-scroll">
                    <v-container>
                      <v-row>
                        <v-col cols="3" v-for="n in monthlyFeeList" :key="n.feeCd">
                          <v-item v-slot="{ active, toggle }">
                            <v-card :color="active ? 'blue' : 'grey'" class="align-center monthly-fee-option" dark @click="toggle">
                              <div class="flex-grow-2 text-center monthly-fee-name">{{ n.feeName }}</div>
                              <br />
                              <div class="text-caption text-center monthly-fee-desc">{{ n.feeExplanation }}</div>
                            </v-card>
                          </v-item>
                        </v-col>
                      </v-row>
                    </v-container>
                  </div>
                </v-item-group> </v-row
              ><v-card class="monthly-payment-row">
                <v-row>
                  <v-checkbox
                    color="primary"
                    v-model="isConsulting"
                    :label="'컨설팅 적용'"
                    class="monthly-consulting-check"
                    @change="consultingValueChanged"
                  />
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span>{{ '소중안 시스템을 이용해 보신 적 있다면 해제해 주세요.' }}</span>
                    <br />
                    <span>{{ '컨설팅 미적용 시, 결제 승인이 거절될 수 있습니다.' }}</span>
                  </v-tooltip>
                </v-row>
              </v-card>
              <v-card class="monthly-payment-row">
                <div class="form-label monthly-form-label">활성화 기간</div>
                <v-row no-gutters>
                  <v-col>
                    <span class="pt-1 d-flex align-center monthly-info-text">{{ monthlyFeeDtS + ' ~ ' + monthlyFeeDtE }}</span>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="monthly-payment-row">
                <div class="form-label monthly-form-label">자동결제(다음달부터 적용)</div>
                <v-row no-gutters>
                  <span class="monthly-info-text">{{ formatToKoreanWon(selectedMontlyFeeData.feeAmount) + '원 / 월' }} (VAT 별도)</span>
                </v-row>
              </v-card>
              <v-card v-if="discountList.length > 0" class="monthly-payment-row monthly-discount-row">
                <div class="form-label monthly-form-label">적용된 할인</div>
                <v-row no-gutters>
                  <span v-for="dis in discountList" v-bind:key="dis.discountCd" class="monthly-discount-tag">{{ dis.discountName }}</span>
                </v-row>
              </v-card>
              <v-card class="monthly-payment-row monthly-summary-card">
                <div class="form-label monthly-form-label">요금 합계(1자리 올림)</div>
                <v-row class="monthly-summary-row">{{ '첫 결제 요금 = ' + formatToKoreanWon(selectedMontlyFeeData.feeAmount) + '원' }}</v-row>
                <v-row class="monthly-summary-row">{{ '컨설팅 요금(정액형)= ' + formatToKoreanWon(consultingAmount) + '원' }}</v-row>
                <v-row v-if="totalDiscountAmount > 0" class="monthly-summary-row">
                  <span>{{ '정가 할인 = ' + totalDiscountAmount + '원' }}</span>
                </v-row>
                <v-row v-if="totalDiscountPercent > 0" class="monthly-summary-row">
                  <span>{{ '추가 할인 = ' + totalDiscountPercent + '%' }}</span>
                </v-row>
                <v-row class="monthly-summary-row">{{ '요금 합계 = ' + formatToKoreanWon(totalPaymentAmount) + '원' }}</v-row>
                <v-row class="monthly-summary-row">{{ 'VAT(10%) = ' + formatToKoreanWon(vat) + '원' }}</v-row>
              </v-card>
              <v-card class="monthly-payment-row monthly-total-row">
                <v-row no-gutters>
                  <v-col>
                    <div class="d-flex justify-space-between">
                      <div class="form-label monthly-form-label">결제 금액</div>
                      <div class="form-label monthly-form-label monthly-form-hint">(*VAT 10% 포함)</div>
                    </div>
                    <v-text-field
                      readonly
                      solo
                      hide-details="auto"
                      prefix="￦"
                      class="editor_bg rounded right-input monthly-total-input"
                      :value="formatToKoreanWon(totalPaymentAmount + vat)"
                    />
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="monthly-payment-row monthly-submit-row">
                <v-btn color="primary" elevation="0" large class="monthly-submit-btn" @click="btnPayment()">{{ '결제하기' }}</v-btn>
              </v-card>
            </v-card>
          </template>
        </i-card-vertical>
        <!-- 적용중인 요금제가 있을 경우-->
        <i-card-vertical v-else class="w-hfull monthly-upgrade-card" headerTitle="요금제 업그레이드" device="web">
          <template v-slot:body>
            <v-card v-if="activeMonthlyFeeData.billingDueDt == null" class="monthly-upgrade-disabled">
              <div class="d-flex align-center justify-center h-full">
                <h3 class="grey--text monthly-upgrade-msg">{{ '자동결제 중단 된 요금제는 업그레이드 할 수 없습니다.' }}</h3>
              </div>
            </v-card>
            <v-card
              v-else-if="monthlyFeeList.length > 0 || totalPaymentAmount + vat > 0"
              class="d-flex monthly-upgrade-body"
              style="flex-direction: column; gap: 15px"
            >
              <v-row no-gutters class="monthly-payment-section">
                <div class="form-label monthly-form-label">요금제 선택</div>
                <v-item-group mandatory v-model="selection" class="monthly-fee-select-group">
                  <v-row class="monthly-fee-select-row">
                    <v-col v-for="(n, idx) in monthlyFeeList" :key="n.feeCd" cols="12" sm="6" md="3" class="monthly-fee-col">
                      <v-item v-slot="{ active, toggle }" :value="idx">
                        <v-card
                          :class="['monthly-fee-option monthly-fee-option--upgrade', { 'monthly-fee-option--active': active }]"
                          class="d-flex flex-column align-center justify-center"
                          @click="toggle"
                        >
                          <div class="monthly-fee-name" :style="{ color: active ? '#0f172a' : '#1e293b' }">{{ n.feeName }}</div>
                          <div class="monthly-fee-desc" :style="{ color: active ? '#1d4ed8' : '#2563eb' }">{{ n.feeExplanation }}</div>
                        </v-card>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-item-group>
              </v-row>
              <v-card class="monthly-payment-row">
                <div class="form-label monthly-form-label">변경 사항</div>
                <v-row no-gutters>
                  <span class="monthly-info-text"
                    >정액 요금제 및 자동결제 금액 변경 {{ formatToKoreanWon(selectedMontlyFeeData.feeAmount) + '원' }}</span
                  >
                </v-row>
              </v-card>
              <v-card class="monthly-payment-row">
                <div class="form-label monthly-form-label">업그레이드 추가 요금</div>
                <v-row no-gutters>
                  <span class="monthly-info-text">
                    {{
                      '업그레이드 요금제(' +
                      formatToKoreanWon(selectedMontlyFeeData.feeAmount) +
                      '원) - 사용중인 요금제(' +
                      formatToKoreanWon(activeMonthlyFeeData.feeAmount) +
                      '원) = ' +
                      formatToKoreanWon(selectedMontlyFeeData.feeAmount - activeMonthlyFeeData.feeAmount) +
                      '원'
                    }}
                  </span>
                  <!-- 적용기간 * 일할 요금 - 적용기간 * 기존 일할 요금 -->
                </v-row>
              </v-card>
              <v-card v-if="useDay > 0" class="monthly-payment-row">
                <div class="form-label monthly-form-label">기존 사용 기간</div>
                <v-row no-gutters>
                  <v-col class="monthly-info-text">{{ useDay + '일' }}</v-col>
                </v-row>
              </v-card>
              <v-card v-if="discountList.length > 1" class="monthly-payment-row monthly-discount-row">
                <div class="form-label monthly-form-label">적용된 할인</div>
                <v-row no-gutters>
                  <span v-for="dis in discountList" v-bind:key="dis.discountCd" class="monthly-discount-tag">{{ dis.discountName }}</span>
                </v-row>
              </v-card>
              <v-card class="monthly-payment-row monthly-summary-card">
                <div class="form-label monthly-form-label">결제 금액 합계</div>
                <v-row v-if="totalDiscountAmount > 0" class="monthly-summary-row">
                  <span>{{ '정가 할인 = ' + totalDiscountAmount + '원' }}</span>
                </v-row>
                <v-row v-if="totalDiscountPercent > 0" class="monthly-summary-row">
                  <span>{{ '추가 할인 = ' + totalDiscountPercent + '%' }}</span>
                </v-row>
                <v-row class="monthly-summary-row">
                  {{ '업그레이드 추가 요금 = ' + formatToKoreanWon(selectedMontlyFeeData.feeAmount - activeMonthlyFeeData.feeAmount) + '원' }}
                </v-row>
                <v-row v-if="useDay > 0" class="monthly-summary-row">
                  <span>
                    {{
                      '기존 사용 기간 대비 할인 = ' +
                      formatToKoreanWon(Math.floor((useDay / 30) * (selectedMontlyFeeData.feeAmount - activeMonthlyFeeData.feeAmount))) +
                      '원'
                    }}
                  </span>
                </v-row>
                <v-row class="monthly-summary-row">{{ '요금 합계(1자리 올림) = ' + formatToKoreanWon(totalPaymentAmount) + '원' }}</v-row>
                <v-row class="monthly-summary-row">{{ 'VAT(10%) = ' + formatToKoreanWon(vat) + '원' }}</v-row>
                <!-- <v-row>{{ '정액형 컨설팅 = ' + formatToKoreanWon(consultingAmount) + '원' }}</v-row> -->
              </v-card>
              <v-card class="monthly-payment-row monthly-total-row">
                <v-row no-gutters>
                  <v-col>
                    <div class="d-flex justify-space-between">
                      <div class="form-label monthly-form-label">결제 금액</div>
                      <div class="form-label monthly-form-label monthly-form-hint">(*VAT 10% 포함)</div>
                    </div>
                    <v-text-field
                      readonly
                      solo
                      hide-details="auto"
                      prefix="￦"
                      class="editor_bg rounded right-input monthly-total-input"
                      :value="formatToKoreanWon(totalPaymentAmount + vat)"
                    />
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="monthly-payment-row monthly-submit-row">
                <v-btn color="primary" elevation="0" large class="monthly-submit-btn" @click="btnUpgradePayment()">{{ '업그레이드' }}</v-btn>
              </v-card>
            </v-card>
            <v-card v-else class="monthly-upgrade-disabled">
              <div class="d-flex align-center justify-center h-full">
                <h3 class="grey--text monthly-upgrade-msg">{{ '업그레이드 할 수 있는 요금제가 없습니다.' }}</h3>
              </div>
            </v-card>
          </template>
        </i-card-vertical>
      </v-sheet>
      <i-card-right :useBtnList="buttonUseList" @btnSearch="btnSearch(false)"></i-card-right>
    </v-sheet>
  </v-container>
</template>
<script>
import iDxPopup from '@/components/common/iDxPopup.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import CancelPopup from './CancelPopup.vue'
//
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import {
  getMonthlyFeeList,
  getMonthlyFeeUpgradeList,
  getActiveMonthlyFee,
  getActiveMonthlyCompList,
} from '@/api/sojunganManagement/monthlyPaymentManage.js'
import { getDiscountListByFee } from '@/api/feeManage/discountManage.js'
import { getOrderId, getCustomerInfo, insertBilling, stopBilling, restoreBilling } from '@/payment/api/toss.js'
import { getCommonCode } from '@/api/common/commonApi'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    'i-card-vertical': iCardVertical,
    IDateTimePicker,
    'i-dxpopup': iDxPopup,
    CancelPopup,
  },

  data() {
    return {
      dxDataGridRef: 'monthlyPaymentGrid',
      buttonUseList: ['btnSearch'],
      selection: null,
      monthlyFeeList: [], // 선택 가능한 정액 요금제 리스트
      monthlyFeeUpgradeList: [], // 업그레이드 가능한 정액 요금제 리스트
      monthlyFeeDtS: new Date(), // 신규 활성화 시작일
      monthlyFeeDtE: new Date(), // 신규 활성화 종료일

      activeMonthlyFee: true, // 기존 활성화 정액 요금제 유무

      activeMonthlyFeeData: {
        activeMonthlyFeeCd: null, // 기존 활성화 정액 요금제 코드
        feeName: null, // 기존 활성화 정액 요금제 명
        activeMonthlyFeeDtS: null, // 기존 정액 요금제 활성화 시작일
        activeMonthlyFeeDtE: null, // 기존 정액 요금제 활성화 종료일
        feeCd: null, // 기존 자동 결제 예정 정액 요금제 코드
        feeAmount: null, // 기존 자동 결제 요금
        billingDueDt: null, // 기존 자동 결제 예정일
      },

      selectedMontlyFeeData: {
        // 선택된 요금제
        feeCd: null, // 선택된 요금제 코드
        feeName: '',
        feeAmount: 0, // 선택된 요금제 요금
      },

      discountList: [], // 할인 리스트
      activeMonthlyCompList: [], // 정액제 적용된 사업장 리스트

      useDay: null, // 업그레이드 적용 기간 (null 또는 30 일 경우 1개월 전체)
      totalDiscountAmount: 0, // 총 정가 할인 가격
      totalDiscountPercent: 0, // 총 추가 할인 퍼센트
      totalPaymentAmount: 0,
      vat: 0,
      consultingAmount: 0,
      originConsultingAmount: 0,
      tossPopupVisible: false,
      checkAmount: 0,
      // toss 결제 정보
      orderId: '',
      orderName: '',
      customerName: '',
      customerEmail: '',
      customerMobilePhone: '',
      customerKey: '',
      cancelPopupVisible: false,
      constructData: {
        clntId: null,
        compId: null,
        feeCd: null,
        constructDtS: null,
        constructDtE: null,
        orderId: null,
        feeAmount: null,
        discountAmount: 0,
        discountPercent: 0,
      },
      isConsulting: true,
      isMembership: false, // 회원사 상태값
    }
  },
  watch: {
    selection() {
      if (this.activeMonthlyFee) {
        this.calcUpgradePaymentAmount()
      } else {
        this.calcPaymentAmount()
      }
    },
  },
  beforeMount() {},
  mounted() {},
  created() {},
  activated() {
    console.log('active')
    this.init()
  },
  methods: {
    init() {
      // 사용중인 요금제가 있는지 조회
      let params = {
        clntId: this.getClntId(),
      }
      getActiveMonthlyFee(params).then((res) => {
        // 사용중인 요금제가 있는 경우
        if (res.length > 0) {
          this.activeMonthlyFee = true
          this.activeMonthlyFeeData = res[0]
          console.log('activeMonthlFeeData', res[0])

          this.setMonthlyFeeUpgrade()
        }
        // 사용중인 요금제가 없는 경우
        else {
          this.activeMonthlyFee = false
          this.setMonthlyFeeSignup()
        }
      })

      getCustomerInfo(params).then((res) => {
        this.customerName = res.customerName
        this.customerEmail = res.customerEmail
        this.customerKey = res.customerKey
      })
    },
    chMod() {
      if (this.activeMonthlyFee) {
        this.activeMonthlyFee = false
      } else {
        this.activeMonthlyFee = true
      }
    },
    formatToKoreanWon(value) {
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      }
      return 0
    },
    async calcPaymentAmount() {
      // 정액 요금제 등록 비용 계산
      this.selectedMontlyFeeData = this.monthlyFeeList[this.selection]

      let calcAmount = this.selectedMontlyFeeData.feeAmount

      // 선택된 요금제에 해당하는 할인 목록 조회
      let params = {
        feeCd: this.selectedMontlyFeeData.feeCd,
      }

      // FEE003 코드 가져오기
      const commonCodeRes = await getCommonCode('FEE003')
      const match = commonCodeRes.list.find((item) => item.minorCd === 'monthly')

      // 요금제 타입에 따른 consultingAmount 설정
      this.consultingAmount = match ? match.extra1 : 0
      this.originConsultingAmount = _.cloneDeep(this.consultingAmount)
      getDiscountListByFee(params).then((res) => {
        if (res.success) {
          this.discountList = res.list

          // 할인 총량 계산
          this.discountList.forEach((dis) => {
            if (dis.method == '00001') {
              this.totalDiscountAmount += dis.discountAmount
            }
            if (dis.method == '00002') {
              this.totalDiscountPercent += parseInt(dis.discountPercent)
            }
          })

          // 할인 총량 반영 : 신규 정액 요금제 계산
          calcAmount -= this.totalDiscountAmount
          calcAmount = Math.ceil((calcAmount * (100 - this.totalDiscountPercent)) / 100 / 10) * 10 + Number(this.consultingAmount)
          this.totalPaymentAmount = calcAmount
          this.vat = calcAmount / 10
        }
      })
    },
    calcUpgradePaymentAmount() {
      // 업그레이드 비용 계산
      this.selectedMontlyFeeData = this.monthlyFeeList[this.selection]
      // 남은 기간 계산
      let orgStart = new Date(this.activeMonthlyFeeData.activeMonthlyFeeDtS)
      let start = new Date()
      let diffDays = Math.abs(start.getTime() - orgStart.getTime())

      let calcAmount = 0

      // 일자가 동일한 경우
      if (orgStart.getTime() == start.getTime()) {
        this.useDay = null
        calcAmount = this.selectedMontlyFeeData.feeAmount - this.activeMonthlyFeeData.feeAmount
      }
      // 일자가 다른 경우
      // (신규 - 기존 차이) * 신규 활성화 기간 일수 / 30 = 결제 금액
      else {
        this.useDay = Math.ceil(diffDays / (1000 * 60 * 60 * 24)) - 1
        calcAmount =
          Math.ceil(Math.floor(((this.selectedMontlyFeeData.feeAmount - this.activeMonthlyFeeData.feeAmount) * (30 - this.useDay)) / 30) / 10) * 10
      }

      this.vat = calcAmount / 10
      this.totalPaymentAmount = calcAmount
    },
    setMonthlyFeeSignup() {
      // 정액 요금제 등록 준비
      let params = {
        clntId: this.getClntId(),
      }
      // 사용자가 선택 가능한 정액 요금제 리스트 조회
      getMonthlyFeeList(params)
        .then((res) => {
          this.monthlyFeeList = res.list
          if (this.monthlyFeeList.length > 0) {
            if (this.monthlyFeeList[0].feeSubType == '00001') {
              this.isMembership = true
            } else {
              this.isMembership = false
            }
          } else {
            this.isMembership = false
          }
        })
        .finally(() => {
          if (!this.isMembership) {
            this.vToastifyPrompt(
              this.$t('회원사가 아닌 고객은 일반 요금제만 사용이 가능합니다.<br/> 사업장(공사)등록 화면으로 이동하시겠습니까?'),
              'info',
              async (current) => {
                const toRouter = {
                  name: 'CompManage',
                  params: {
                    data: { monthlyPaymentAlert: true },
                  },
                }
                this.$router.push(toRouter)
              }
            )
          }
        })

      // 현재 날짜를 기준으로 신규 활성화 기간 계산 (1개월)
      let dts = new Date()
      this.monthlyFeeDtS = dts.getFullYear() + '.' + (dts.getMonth() + 1) + '.' + dts.getDate()
      let dte = new Date()
      dte.setMonth(dte.getMonth() + 1)
      this.monthlyFeeDtE = dte.getFullYear() + '.' + (dte.getMonth() + 1) + '.' + dte.getDate()
    },
    setMonthlyFeeUpgrade() {
      this.isMembership = true
      // 정액 요금제 업그레이드 준비
      console.log('Upgrade')
      let params = {
        clntId: this.getClntId(),
      }

      // 고객사가 정액 요금제를 적용중인 사업장(공사) 리스트 조회
      getActiveMonthlyCompList(params).then((res) => {
        this.activeMonthlyCompList = res.list
      })

      // 고객사가 업그레이드 가능한 정액 요금제 리스트 조회
      getMonthlyFeeUpgradeList(params).then((res) => {
        this.monthlyFeeList = res.list

        // 업그레이드 가능한 요금제가 존재한다면
        console.log('FeeDt Calc')
        if (this.monthlyFeeList.length > 0) {
          // 기존 날짜를 기준으로 신규 활성화 기간 계산, 오늘 ~ 기존 종료일
          let dts = new Date()
          this.monthlyFeeDtS = dts.getFullYear() + '.' + (dts.getMonth() + 1) + '.' + dts.getDate()
          let dte = new Date(this.activeMonthlyFeeData.activeMonthlyFeeDtE)
          this.monthlyFeeDtE = dte.getFullYear() + '.' + (dte.getMonth() + 1) + '.' + dte.getDate()
        }
      })
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    btnPayment() {
      // 정액 요금제 용 카드 등록 및 첫 자동결제 동작 시키기

      /* 신규 정액 요금제 결제 */
      let params = {
        clntId: this.getClntId(),
        feeCd: this.selectedMontlyFeeData.feeCd,
        customerKey: this.customerKey,
        paymentAmount: this.totalPaymentAmount,
        extraAmount: this.consultingAmount,
      }
      console.log('## param', params)

      insertBilling(params, true)
        .then((res) => {
          if (res.success) {
            this.toBilling()
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            if (error.response.data.code == -2001) {
              this.vToastify(this.$t(error.response.data.msg), 'info')
            }
          }
        })
    },
    btnUpgradePayment() {
      // 정액 요금제 업그레이드는 추가금 결제로 진행, 일반 결제 처리 후 order_billing 정보만 업데이트
      // 추가금 결제는 변경용 fee_cd와 결제 추가금 fee_cd로 분리해야한다.
      // 결제 추가금 fee_cd로 결제하고 parent_order_id에 기존 결제 했던 정액 요금제 금액 연결

      // OrderId 발급
      let param = {
        orderType: 'pay',
      }

      getOrderId(param).then((res) => {
        const paymentData = {
          orderId: res.orderId, // 주문 번호
          orderName: this.selectedMontlyFeeData.feeName, // 주문 명
          feeCd: this.selectedMontlyFeeData.feeCd, // 요금제 코드( 상품 코드 등)
          feeAmount: this.totalPaymentAmount + this.vat, // 요금
          clntId: this.getClntId(),
          compId: this.getCompId(),
          customerName: this.customerName, // 고객 명
          customerEmail: this.customerEmail, // 고객 메일 주소
          customerKey: this.customerKey, // 고객 Key
          activeFeeType: 'monthly', // 결제 종류,
          route: 'MonthlyPaymentManage',
        }
        const toRouter = {
          name: 'Checkout',
          params: {
            data: paymentData,
          },
        }

        console.log('paymentData', paymentData)
        this.$router.push(toRouter)
      })
    },
    btnBillingInfoChange() {
      /* 자동 결제 수단 변경 */
      this.vToastifyPrompt(this.$t('결제 수단을 변경 하시겠습니까?'), 'info', async (current) => {
        this.toBilling()
      })
    },
    btnStopBilling() {
      /* 자동 결제 중단 */
      this.vToastifyPrompt(this.$t('자동 결제를 중단 하시겠습니까? (현재 이용중인 정액 요금제는 유지됩니다.)'), 'info', async (current) => {
        // billingDueDt = null 처리
        const params = {
          clntId: this.getClntId(),
        }
        stopBilling(params).then(() => {
          this.init()
        })
      })
    },
    btnRestoreBilling() {
      /* 자동 결제 복원 */
      this.vToastifyPrompt(this.$t('자동 결제를 복원 하시겠습니까?'), 'info', async (current) => {
        // billingDueDt = null 처리
        const params = {
          clntId: this.getClntId(),
        }
        restoreBilling(params).then(() => {
          this.init()
        })
      })
    },
    btnPaymentCancel() {
      // 취소 정보 입력
      this.constructData.clntId = this.getClntId()
      this.constructData.feeCd = this.activeMonthlyFeeData.activeMonthlyFeeCd
      this.constructData.constructDtS = this.activeMonthlyFeeData.activeMonthlyFeeDtS.replaceAll('.', '')
      this.constructData.constructDtE = this.activeMonthlyFeeData.activeMonthlyFeeDtE.replaceAll('.', '')
      this.constructData.orderId = this.activeMonthlyFeeData.orderId
      this.constructData.feeAmount = this.activeMonthlyFeeData.feeAmount

      this.cancelPopupVisible = true
    },
    async btnSearch(flag) {
      this.init()
    },
    cancelPopupClose(completed) {
      this.cancelPopupVisible = false
      if (completed) {
        this.btnSearch(false)
      }
    },
    toBilling() {
      const paymentData = {
        customerName: this.customerName,
        customerEmail: this.customerEmail,
        customerKey: this.customerKey,
        // paymentAmount: this.totalPaymentAmount,
        // extraAmount: this.consultingAmount
      }
      const toRouter = {
        name: 'Billing',
        params: {
          data: paymentData,
        },
      }
      this.$router.push(toRouter)
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    onFocusedRowChanged(e) {
      console.log('@@ e', e)
    },
    consultingValueChanged(e) {
      if (e) {
        this.consultingAmount = _.cloneDeep(this.originConsultingAmount)
        this.totalPaymentAmount += parseInt(this.consultingAmount)
      } else {
        this.totalPaymentAmount -= parseInt(this.originConsultingAmount)
        this.consultingAmount = 0
      }
      this.vat = this.totalPaymentAmount / 10
    },
  },
}
</script>

<style scoped>
/* ===== 공통 ===== */
.right-input >>> input {
  text-align: right;
}

/* ===== 요금제 안내 카드 ===== */
.monthly-guide-card >>> .v-card,
.monthly-guide-card >>> .v-sheet {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px;
}

.monthly-guide-inner {
  padding: 8px 0;
}

.monthly-guide-no-member {
  padding: 24px 16px;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 30%);
  border-radius: 10px;
  border: 1px solid #fcd34d;
}

.monthly-guide-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #92400e;
  margin: 0;
  letter-spacing: -0.02em;
}

.monthly-guide-subtitle {
  font-size: 0.95rem;
  color: #b45309;
  margin: 0;
  font-weight: 500;
}

.monthly-guide-body {
  padding: 4px 0;
  max-width: 100%;
}

.monthly-guide-block {
  margin-bottom: 16px;
}

.monthly-guide-block:last-of-type {
  margin-bottom: 0;
}

.monthly-guide-section-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 8px 0;
  padding-bottom: 6px;
  border-bottom: 2px solid #3b82f6;
  display: inline-block;
  letter-spacing: -0.01em;
}

.monthly-guide-paragraph span,
.monthly-guide-paragraph {
  display: block;
  font-size: 0.9rem;
  line-height: 1.65;
  color: #475569;
  margin-bottom: 4px;
}

.monthly-guide-example {
  padding: 12px 14px;
  background: #eff6ff;
  border-radius: 8px;
  border-left: 4px solid #3b82f6;
  margin: 8px 0;
}

.monthly-guide-example span {
  display: block;
  font-size: 0.875rem;
  line-height: 1.6;
  color: #1e40af;
}

.monthly-guide-flow {
  padding: 10px 12px;
  background: #f0fdf4;
  border-radius: 8px;
  margin: 8px 0;
}

.monthly-guide-flow span {
  display: block;
  font-size: 0.875rem;
  line-height: 1.55;
  color: #166534;
  font-family: 'Consolas', 'Monaco', monospace;
}

.monthly-guide-notice {
  padding: 12px 14px;
  background: #fefce8;
  border-radius: 8px;
  border: 1px solid #fde047;
}

.monthly-guide-notice span {
  display: block;
  font-size: 0.9rem;
  line-height: 1.6;
  color: #713f12;
}

/* ===== 사용중인 요금제 ===== */
.monthly-current-card >>> .v-card {
  border-radius: 10px;
}

.monthly-current-inner {
  background: transparent;
  box-shadow: none;
}

.monthly-current-fields {
  padding: 4px 0;
}

.monthly-info-row {
  padding: 14px 16px !important;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: none !important;
}

.monthly-form-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 6px !important;
}

.monthly-info-value {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
}

.monthly-action-buttons {
  padding: 16px 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.monthly-action-btn {
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 8px !important;
  letter-spacing: -0.01em;
}

.monthly-divider {
  margin: 12px 0 !important;
  border-color: #e2e8f0 !important;
}

.monthly-grid-section {
  padding: 12px 0 0 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* ===== 정액 요금제 결제 / 업그레이드 ===== */
.monthly-payment-card >>> .v-card,
.monthly-upgrade-card >>> .v-card {
  border-radius: 12px;
}

.monthly-payment-body,
.monthly-upgrade-body {
  padding: 4px 0;
  background: transparent !important;
}

.monthly-payment-section {
  margin-bottom: 4px;
}

/* 요금제 선택 카드 - 정사각형, 가로 스크롤, 파란 테마 */
.monthly-fee-select-group {
  width: 100%;
}

.monthly-fee-select-row {
  margin: 0 -8px;
}

.monthly-fee-col {
  padding: 8px !important;
}

.monthly-fee-select-group .v-card {
  width: 100%;
  min-height: 120px;
  height: auto;
  border-radius: 12px !important;
  transition: all 0.25s ease;
  cursor: pointer;
  border: 2px solid #93c5fd;
  background: #eff6ff !important;
  overflow: hidden;
  padding: 16px 12px !important;
  color: #1e293b !important;
}

/* 카드 내부 글자색 강제 (테마 덮어쓰기) */
.monthly-fee-select-group >>> .v-card__text,
.monthly-fee-select-group .v-card {
  color: #1e293b !important;
}
.monthly-fee-select-group >>> .v-card .monthly-fee-name {
  color: #1e293b !important;
}
.monthly-fee-select-group >>> .v-card .monthly-fee-desc {
  color: #2563eb !important;
}
.monthly-fee-select-group >>> .v-card.monthly-fee-option--active .monthly-fee-name {
  color: #0f172a !important;
}
.monthly-fee-select-group >>> .v-card.monthly-fee-option--active .monthly-fee-desc {
  color: #1d4ed8 !important;
}

.monthly-fee-select-group .v-card:hover {
  border-color: #60a5fa;
  background: #dbeafe !important;
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.2);
  transform: translateY(-2px);
}

.monthly-fee-option--active,
.monthly-fee-select-group .v-card.monthly-fee-option--active {
  border-color: #2563eb !important;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%) !important;
  box-shadow: 0 4px 20px rgba(37, 99, 235, 0.3);
}

.monthly-fee-option--active:hover {
  border-color: #1d4ed8 !important;
  box-shadow: 0 6px 24px rgba(37, 99, 235, 0.35);
}

.monthly-fee-option {
  min-height: 0;
}

.monthly-fee-option--upgrade {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: flex-start !important;
  box-sizing: border-box;
}

.monthly-fee-option--upgrade .monthly-fee-name {
  color: #1e293b !important;
  margin-bottom: 1px;
  flex-shrink: 0;
}

.monthly-fee-option--upgrade.monthly-fee-option--active .monthly-fee-name {
  color: #0f172a !important;
}

.monthly-fee-name {
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: -0.02em;
  line-height: 1.25;
  text-align: center;
  word-break: keep-all;
  color: inherit;
}

.monthly-fee-option--upgrade .monthly-fee-desc {
  color: #2563eb !important;
  text-align: center;
  word-break: keep-all;
  flex-shrink: 0;
  flex: 1;
  min-height: 0;
}

.monthly-fee-option--upgrade.monthly-fee-option--active .monthly-fee-desc {
  color: #1d4ed8 !important;
}

.monthly-fee-desc {
  font-size: 0.75rem;
  line-height: 1.35;
  color: #2563eb !important;
}

.monthly-payment-row {
  padding: 12px 16px !important;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: none !important;
}

.monthly-consulting-check {
  margin-bottom: 0;
}

.monthly-info-text {
  font-size: 0.95rem;
  color: #334155;
  line-height: 1.5;
}

.monthly-discount-row .monthly-discount-tag {
  display: inline-block;
  padding: 4px 10px;
  margin: 2px 4px 2px 0;
  background: #dbeafe;
  color: #1d4ed8;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
}

.monthly-summary-card {
  background: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
}

.monthly-summary-row {
  font-size: 0.9rem;
  color: #475569;
  line-height: 1.7;
  margin: 2px 0 !important;
}

.monthly-total-row {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%) !important;
  border-color: #93c5fd !important;
  padding: 16px !important;
}

.monthly-form-hint {
  font-size: 0.75rem !important;
  font-weight: 500;
  color: #64748b;
}

.monthly-total-input >>> input {
  font-size: 1.15rem !important;
  font-weight: 700 !important;
  color: #1e40af !important;
}

.monthly-submit-row {
  padding: 20px 16px !important;
  background: transparent !important;
  border: none !important;
}

.monthly-submit-btn {
  font-weight: 700 !important;
  font-size: 1rem !important;
  padding: 10px 32px !important;
  border-radius: 10px !important;
  text-transform: none !important;
  letter-spacing: -0.02em;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.35) !important;
}

.monthly-upgrade-disabled {
  padding: 32px 24px !important;
  background: #f1f5f9 !important;
  border-radius: 10px;
  border: 1px dashed #94a3b8;
}

.monthly-upgrade-msg {
  font-size: 1rem !important;
  color: #64748b !important;
  font-weight: 500;
  margin: 0;
}
</style>
